import { Route } from '@angular/router';
import { WorkflowWizardComponent } from '@features/requests';
import { PermissionGuard } from '@core/guards';
import { OutkeepPermission } from '@outkeep/shared';
import { WorkflowsListComponent } from './';

export const workflowsRoutes: Route[] = [
  {
    path: '',
    canActivate: [PermissionGuard],
    data: {
      permission: OutkeepPermission.LogistRequestWorkflowsView,
    },
    component: WorkflowsListComponent,
  },
  {
    path: ':workflowId/:nodeId/:formId',
    canActivate: [PermissionGuard],
    data: {
      permission: OutkeepPermission.LogistRequestWorkflowsView,
    },
    component: WorkflowWizardComponent,
  },
  {
    path: 'final',
    canActivate: [PermissionGuard],
    data: {
      permission: OutkeepPermission.LogistRequestWorkflowsView,
      // Финальная страница определяется явно маршрутом, а не отсутствием регламента
      isFinalRoute: true,
    },
    component: WorkflowWizardComponent,
  },
];

/**
 * РЕГЛАМЕНТ1(REQUESTWORKFLOW)✅   РЕГЛАМЕНТ2(REQUESTWORKFLOW)✅
 * НОДА   НОДА2✅                  НОДА1✅
 * ФОРМА1 ФОРМА2 ФОРМА3            ФОРМА1✅ ФОРМА2
 *                                 < тут >
 *
 *
 * [submission1] [submission2]
 */
